import { ScheduledTask } from "@/data/models/Task";
import { DataItem, DataSet } from "vis-timeline/standalone";

export enum ItemType {
  UNCONFIRMED_TASK = "UNCONFIRMED_TASK",
  CONFIRMED_TASK = "CONFIRMED_TASK",
  TRAVEL_TIME = "TRAVEL_TIME",
  BREAK = "BREAK",
}

export interface TimlineDataItem extends DataItem {
  id: string;
  itemType: ItemType;
  start: Date;
  end: Date;
  isMoving?: boolean;
  scheduledTask?: ScheduledTask;
}

export class TimelineItemDiffer {
  previousItems = new Map<string, TimlineDataItem>();
  senderId = "differ";

  update(newItems: TimlineDataItem[], dataSet: DataSet<TimlineDataItem>) {
    const updated: TimlineDataItem[] = [];
    const removed: string[] = [];

    newItems.forEach((item) => {
      const previousItem = this.previousItems.get(item.id);

      if (previousItem) {
        const didStopMoving = previousItem.isMoving && !item.isMoving;

        const didChange =
          didStopMoving ||
          previousItem.group != item.group ||
          previousItem.start.getTime() != item.start.getTime() ||
          previousItem.end.getTime() != item.end.getTime() ||
          previousItem.editable !== item.editable;

        this.previousItems.delete(item.id);

        if (didChange) {
          updated.push(item);
        }
      } else {
        updated.push(item);
      }
    });

    [...this.previousItems.keys()].forEach((outdatedKey) => {
      removed.push(outdatedKey);
    });

    this.previousItems.clear();

    newItems.forEach((item) => {
      this.previousItems.set(item.id, item);
    });

    dataSet.update(updated, this.senderId);
    dataSet.remove(removed, this.senderId);
  }
}
